import axios from "axios";
import {
  activeLinksRequested,
  activeLinksRequestFailed,
  activeLinksRequestSucceeded,
} from "../slices/GetActiveLinksByCountryRoleSlice";

const selectedCountry = localStorage.getItem("selectedCountry");
const recoveredData = localStorage.getItem("sesion");
const parsedData = recoveredData ? JSON.parse(recoveredData) : null;
const rolsArray = parsedData?.rols || [];
let roles = "";

if (rolsArray.length) {
  const userRoles = rolsArray.filter(
    (rol) => rol.country.countryName === selectedCountry
  );

  roles = userRoles.map((rol) => rol.roleName).join(",") || "Basic";
} else {
  roles = "Basic";
}

const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Menu/GetActiveLinksByCountryRole?country=${encodeURIComponent(
  selectedCountry
)}&roles=${encodeURIComponent(roles)}`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const getActiveLinksByCountryRole = () => async (dispatch) => {
  try {
    dispatch(activeLinksRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(activeLinksRequestSucceeded(response.data));
  } catch (error) {
    dispatch(activeLinksRequestFailed(error.message));
  }
};
